import React from 'react';
import { motion } from 'framer-motion';

const CameraAngleFilePreview = ({ files = [], primaryFile = null }) => {
  // 활성화된 파일만 필터링
  const activeFiles = files.filter(file => file.isActive);

  if (activeFiles.length === 0 && !primaryFile) {
    return (
      <div className="file-preview-empty">
        <p>등록된 앵글 파일이 없습니다.</p>
      </div>
    );
  }

  return (
    <div className="camera-angle-file-preview">
      {primaryFile && (
        <div className="primary-file-section">
          <h4 className="section-title">기본 앵글 파일</h4>
          <div className="file-card primary">
            <div className="file-icon">📄</div>
            <div className="file-details">
              <div className="file-name">{primaryFile.fileName}</div>
              {primaryFile.originalFileName && (
                <div className="original-name">{primaryFile.originalFileName}</div>
              )}
              <div className="file-meta">
                <span className="resource-id">ID: {primaryFile.fileResourceId}</span>
                <span className="badge primary-badge">기본</span>
              </div>
            </div>
          </div>
        </div>
      )}

      {activeFiles.length > 0 && (
        <div className="all-files-section">
          <h4 className="section-title">
            전체 앵글 파일 ({activeFiles.length}개)
          </h4>
          <div className="files-grid">
            {activeFiles.map((file, index) => (
              <motion.div
                key={file.id}
                className={`file-card ${
                  primaryFile && file.id === primaryFile.id ? 'is-primary' : ''
                }`}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
              >
                <div className="file-order-badge">{file.displayOrder}</div>
                <div className="file-icon">📄</div>
                <div className="file-details">
                  <div className="file-name">{file.fileName}</div>
                  {file.originalFileName && file.originalFileName !== file.fileName && (
                    <div className="original-name">{file.originalFileName}</div>
                  )}
                  <div className="file-meta">
                    <span className="resource-id">ID: {file.fileResourceId}</span>
                    {primaryFile && file.id === primaryFile.id && (
                      <span className="badge primary-badge">기본</span>
                    )}
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      )}

      <style jsx="true">{`
        .camera-angle-file-preview {
          padding: 20px 0;
        }

        .file-preview-empty {
          text-align: center;
          padding: 40px;
          color: #999;
          background: #f9f9f9;
          border-radius: 8px;
        }

        .primary-file-section,
        .all-files-section {
          margin-bottom: 30px;
        }

        .section-title {
          font-size: 16px;
          font-weight: 600;
          color: #333;
          margin-bottom: 15px;
          padding-bottom: 8px;
          border-bottom: 2px solid #e0e0e0;
        }

        .file-card {
          display: flex;
          align-items: flex-start;
          padding: 15px;
          background: white;
          border: 1px solid #e0e0e0;
          border-radius: 8px;
          position: relative;
          transition: all 0.2s ease;
        }

        .file-card:hover {
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
          transform: translateY(-2px);
        }

        .file-card.primary {
          border-color: #4caf50;
          background: #f1f8f4;
        }

        .file-card.is-primary {
          border-color: #4caf50;
        }

        .file-order-badge {
          position: absolute;
          top: -10px;
          right: -10px;
          width: 28px;
          height: 28px;
          background: #2196f3;
          color: white;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 12px;
          font-weight: 600;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
        }

        .file-icon {
          font-size: 32px;
          margin-right: 15px;
          flex-shrink: 0;
        }

        .file-details {
          flex: 1;
          min-width: 0;
        }

        .file-name {
          font-weight: 500;
          color: #333;
          margin-bottom: 4px;
          word-break: break-word;
        }

        .original-name {
          font-size: 13px;
          color: #666;
          margin-bottom: 8px;
          word-break: break-word;
        }

        .file-meta {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
          align-items: center;
        }

        .resource-id {
          font-size: 12px;
          color: #999;
          font-family: monospace;
          background: #f5f5f5;
          padding: 2px 6px;
          border-radius: 3px;
        }

        .badge {
          font-size: 11px;
          padding: 2px 8px;
          border-radius: 12px;
          font-weight: 500;
        }

        .primary-badge {
          background: #4caf50;
          color: white;
        }

        .files-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
          gap: 15px;
        }

        @media (max-width: 768px) {
          .files-grid {
            grid-template-columns: 1fr;
          }
        }
      `}</style>
    </div>
  );
};

export default CameraAngleFilePreview;